import React, { useState, useEffect, useRef } from "react";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.min.css";
import styles from "./CustomCalendar.module.scss";

interface CustomCalendarProps {
  label: string;
  value: string;
  onChange: (val: string) => void;
  placeholder?: string;
  required?: boolean;
  error?: string;
  size?: "full" | "half" | "third";
  disabled?: boolean;
}

const CustomCalendar: React.FC<CustomCalendarProps> = ({
  label,
  value,
  onChange,
  placeholder = "",
  required = false,
  error = "",
  size = "full",
  disabled = false,
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const flatpickrRef = useRef<any>(null);

  useEffect(() => {
    if (value) setIsFocused(true);
  }, [value]);

  const handleClear = () => {
    onChange("");
    setIsFocused(false);
    if (flatpickrRef.current?.flatpickr) {
      flatpickrRef.current.flatpickr.clear();
    }
  };

  return (
    <div
      className={`${styles.calendarWrapper} ${styles[size]} ${
        isFocused ? styles.focused : ""
      } ${error ? styles.error : ""}`}
    >
      <label
        className={`${styles.floatingLabel} ${
          value || isFocused ? styles.filled : ""
        }`}
      >
        {label} {required && "*"}
      </label>

      <Flatpickr
        ref={flatpickrRef}
        value={value}
        options={{
          enableTime: true,
          dateFormat: "Y-m-d H:i",
        }}
        onChange={(date) =>
          onChange(date[0] ? new Date(date[0]).toISOString() : "")
        }
        onOpen={() => setIsFocused(true)}
        onClose={() => {
          if (!value) setIsFocused(false);
        }}
        placeholder={placeholder}
        disabled={disabled}
        className={styles.customCalendarInput}
      />

      {value && (
        <button
          type="button"
          className={styles.clearButton}
          onClick={handleClear}
        >
          ×
        </button>
      )}

      {error && <div className={styles.errorMessage}>{error}</div>}
    </div>
  );
};

export default CustomCalendar;
